import { GO_LOW_HEIGHT_LIMIT_ADAPTION_OPERATION_NUMBER } from './constants'
import { BreakpointWidthPx } from '../css/BreakpointWidthPx'

export function isTabletOrSmaller() {
  return document.documentElement.clientWidth < BreakpointWidthPx.Small
}

export function isLowHeightDesktopGo() {
  return (
    document.documentElement.clientWidth > BreakpointWidthPx.Small &&
    document.documentElement.clientHeight <
      Number(GO_LOW_HEIGHT_LIMIT_ADAPTION_OPERATION_NUMBER)
  )
}
